import { render, staticRenderFns } from "./StaffListItem.vue?vue&type=template&id=3053f5cb&"
import script from "./StaffListItem.vue?vue&type=script&lang=ts&"
export * from "./StaffListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports